<template>
  <div aria-live="assertive" class="fixed z-40 inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start" @mouseover="keepShow" @mouseleave="goOnClose">
    <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
      <div v-if="visible" class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
        <div class="p-4">
          <div class="flex items-start">
            <div class="flex-shrink-0">
              <svg v-if="type === 'success'" class="h-6 w-6 text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <svg v-else class="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <div class="ml-3 w-0 flex-1 pt-0.5">
              <p class="text-sm font-medium text-gray-900">{{ title }}</p>
              <p class="mt-1 text-sm text-gray-500" v-if="desc.length">{{ desc }}</p>
            </div>
            <div class="ml-4 flex-shrink-0 flex">
              <button @click="() => { this.close() }" class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                <span class="sr-only">Close</span>
                <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationComponent',
  data () {
    return {
      visible: false,
      title: 'Successfully saved!',
      desc: 'Anyone with a link can now view this file.',
      timeout: 3000,
      interval: null,
      type: 'success'
    }
  },
  methods: {
    show (msg = { title: '', desc: '', type: 'success', timeout: 3000 }) {
      this.close()
      if (msg.title.length) this.title = msg.title
      if (msg.desc) {
        this.desc = msg.desc
      } else {
        this.desc = ''
      }
      this.type = msg.type && msg.type.length ? msg.type : 'success'
      this.timeout = msg.timeout ? msg.timeout : 3000
      this.visible = true
      this.interval = setTimeout(() => { this.close() }, this.timeout)
    },
    close () {
      this.visible = false
      this.clearTimeout()
    },
    keepShow () {
      this.visible = true
      this.clearTimeout()
    },
    goOnClose () {
      this.interval = setTimeout(() => { this.close() }, this.timeout)
    },
    clearTimeout () {
      if (!this.interval) return
      clearTimeout(this.interval)
      this.interval = null
    }
  }
}
</script>
